import React from "react";
import Container from "./container";
import { cn } from "../lib/helpers";
import ApplicationItem from "./application-item";

import * as styles from "../styles/components/applications-landing-main.module.css";

interface Slug {
  current?: string;
}

interface ImageAsset {
  asset?: {
    _id: string;
  };
  alt?: string;
}

interface LpSettings {
  image?: ImageAsset;
  _rawExcerpt?: any[];
}

interface Application {
  id?: string;
  title?: string;
  slug?: Slug;
  lp?: LpSettings;
}

interface ApplicationItem {
  node?: Application;
}

interface ApplicationsLandingMainProps {
  applications?: ApplicationItem[];
}

const ApplicationsLandingMain: React.FC<ApplicationsLandingMainProps> = ({ applications }) => {
  if (!applications || applications.length === 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Container>
        <div className="grid">
          {applications.map(({ node }) => (
            <ApplicationItem key={node.id} item={node} />
          ))}
        </div>
      </Container>
    </div>
  );
}

export default ApplicationsLandingMain;
